import { Component, OnInit } from '@angular/core';
import { AppContextService } from '../../services/app-context.service';

@Component({
	selector: 'app-reset-logged-information',
	templateUrl: './reset-logged-information.component.html',
	styleUrls: ['./reset-logged-information.component.css'],
	standalone: false,
})
export class ResetLoggedInformationComponent implements OnInit {
	public resetFeedback: string = '';

	constructor(private appContext: AppContextService) {}

	ngOnInit(): void {
		this.appContext.removeSession();

		this.resetFeedback = "browser's flexcash information has been reseted";
	}
}
